
import React, { useState, useEffect } from 'react';

import { createContext, useContext } from 'react';
import { Route, Routes } from 'react-router-dom';
import { withAuthenticator, Button, Heading, View, Flex, Text, Input } from '@aws-amplify/ui-react';
import { withSession,withSessionOr} from '../components/context/CurrentUserContext';


export const Home = () => {

  return (
    <Homepage />
  );
};



const UserDetails = ({user}) => {

  return (
    <View
      as="div"
      ariaLabel="View example"
      backgroundColor="var(--amplify-colors-white)"
      // borderRadius="6px"
      // border="1px solid var(--amplify-colors-black)"
      // boxShadow="3px 3px 5px 6px var(--amplify-colors-neutral-60)"
      // color="var(--amplify-colors-blue-60)"
      height="20rem"
      maxWidth="100rem"
      padding="1rem"
      width="50rem"
    >

      <h3>User details</h3>

      <Flex direction="column">

        <Text variation="primary" color={'darkblue'}>Email</Text>
        <Text variation="tertiary">{user ? user.email : "n/a"}</Text>


        <Text variation="primary" color={'darkblue'}>Name</Text>
        <Text variation="tertiary">{user ? user.email : "n/a"}</Text>

        <hr/>
        
        <Text variation="primary" color={'darkblue'}>Token</Text>
        <Input variation="tertiary" value={user ? user.tokenType : "n/a"}></Input>

        <Text variation="primary" color={'darkblue'}>Value</Text>
        <Input variation="tertiary" value={user ? user.accessToken : "n/a"}></Input>
      </Flex>
    </View>
  );
};


const NonAuth = ({user}) => {

  return (
      <h3>PleaseAuthenticate</h3>
  );
};


const Homepage = withSession(UserDetails)

export default Home;

